//Public Routes
export const LOGIN = '/login';
export const SSO_LOGIN = '/login/sso';
export const SIGNUP = '/signup';
export const FORGOT_PASSWORD = '/forgot-password';
export const RESET_PASSWORD = '/reset-password';
export const SET_PASSWORD = '/set-password';
export const ICONLIST = '/icons';
export const OTP = '/otp';
export const STATUS_CHECK = '/statuscheck';
export const SSO_CALLBACK = '/sso/callback';
export const ZOOM_INTEGRATION_GUIDE = '/help/zoom-integration';
// Single entry point for external deep links: /go?to=<intent>&<params>
export const GO = '/go';

// Candidate-facing consent page (unauthenticated). Path is fixed by the backend-minted link
// `{BASE_URL}/consent/{token}` (see IA-backend-pybot consent module / adr-0006).
export const CONSENT = '/consent/:token';

//Protected Routes
// The dashboard owns the app index; the campaign/interview list moves to /campaigns.
export const DASHBOARD_OVERVIEW = '/';
export const CAMPAIGN_LIST = '/campaigns';
export const SEARCH = '/search';
export const CANDIDATE_PROFILE = '/job/:jobId/candidateProfile/:id';

export const VIEW_INTERVIEW_REPORT = `/view-report/:roomId`;
export const LIVE_INTERVIEW = `/live-interview/interview/:interviewId/job/:jobId/candidateProfile/:parsedResumeId`;
export const INSTANT_INTERVIEW_SETUP = `/instant-interview/setup/:paramsId`;
export const INTERVIEW_PLANNER = `/planner/:jobId/:parsedResumeId`;
export const ADD_CAMPAIGN = '/add-campaign';
export const EDIT_CAMPAIGN = '/campaign/:paramsId/edit';
export const CAMPAIGN_DETAIL = '/campaign/:jobId';
export const ADD_CANDIDATE_CAMPAIGN = '/campaign/add-candidate';
export const USERS_LIST = '/users';
export const PROFILE = '/profile';
export const INTEGRATIONS = '/integrations';
export const BRANDING_CONSENT = '/branding-consent';
export const ATS_AUTH_GUIDE = '/integrations/guide';
export const NOT_FOUND = '/404';
export const QUESTION_TEMPLATES = '/question-templates';
export const QUESTION_TEMPLATE_NEW = '/question-templates/new';
export const QUESTION_TEMPLATE_EDIT = '/question-templates/:templateId';
